export const getAnimationDurationClassName = () => {
    const duration = localStorage.getItem('duration') || 'forward',
          animationClass = duration === 'forward' ? 'front' : 'back'

    return animationClass
}
